import type { PopupType } from '@shared/types/common';

import { showPopup } from 'library/redux/modal';

import { useAppDispatch } from './use-app-dispatch';

export const usePopup = () => {
	const dispatch = useAppDispatch();

	const popup = (popup: { type: PopupType; text: string }) => dispatch(showPopup(popup));
	return {
		popup,
	};
};
